<template>
    <div>
        <!-- <el-table v-if="loading===false" 
                class="table-responsive table"
                header-row-class-name="thead-light"
                :data="data">
            <el-table-column v-for="(col,index) in columns" :key="index" :label="col" :prop="col"/>
        </el-table> -->


        <el-table v-if="loading === false" 
        class="table-responsive table"
        header-row-class-name="thead-light"
        :data="data">
<el-table-column v-for="(col, index) in columns" 
                 :key="index" 
                 :label="col" 
                 :prop="col">
  
  <template slot-scope="scope">
    <div v-if="!scope.row.isMaximized">
      <span v-if="scope.row[col]">
        <span v-if="scope.row[col].length > 50">
          {{ scope.row[col].substring(0, 50) + '...' }}
        </span>
        <span v-else>
          {{ scope.row[col] }}
        </span>
      </span>
    </div>
    <div v-else>
      {{ scope.row[col] }}
    </div>
  </template>
</el-table-column>

<el-table-column label="Expand">
  <template slot-scope="scope">
    <base-button @click="toggleMaximize(scope.row)">
      <span class="btn-inner--icon">
        <i :class="scope.row.isMaximized ? 'ni ni-fat-delete' : 'ni ni-fat-add'"/>
    </span>
    </base-button>
  </template>
</el-table-column>
</el-table>

<h3 v-else>Loading</h3>




        
        
           


    </div>
</template>

<script>
import {Table,TableColumn} from 'element-ui'

export default {
    name:'result-table',
    components:{
        [Table.name]:Table,
        [TableColumn.name]:TableColumn,
    },
    props:{
        data:Array,
    },
    data(){
        return {
            columns:[],
            loading:true,
        }
    },
    created(){
        console.log(this.data);
        for(var i in this.data){
            var keys=Object.keys(this.data[i]);
            for(var k in keys){
                var key=keys[k];
                if(!this.columns.includes(key))
                    this.columns.push(key);
                
                if(['start_time','end_time','log_time'].includes(key)){
                    var formattedDate=this.formatDefaultDate(this.timestampToDatetime(this.data[i][key]));
                    if(formattedDate!=='aN/aN/NaN aN:aN:aN')
                        this.data[i][key]=formattedDate;
                }
                    
                
                else if(key==='log_level')
                    this.data[i][key]=this.logLevelDescriptions[this.data[i][key]];

                if(typeof this.data[i][key] === 'object' && !Array.isArray(this.data[i][key]) && this.data[i][key] !== null)
                    this.data[i][key]=JSON.stringify(this.data[i][key],null,2);
                
                else if(Array.isArray(this.data[i][key])){
                    // Listeleri daha okunabilir göstermeye çalıştım ama daha kötü oldu.
                    // for(var j in this.data[i][key])
                    //     if(typeof this.data[i][key][j] === 'object' && !Array.isArray(this.data[i][key][j]) && this.data[i][key][j] !== null)
                    //         this.data[i][key][j]=JSON.stringify(this.data[i][key][j])
                    
                    // this.data[i][key]=this.data[i][key].join(', ')
                    this.data[i][key]=JSON.stringify(this.data[i][key],null,2);
                }
            }
        }

        this.columns.sort();
        this.loading=false;
    }, 
    methods:{
        
        toggleMaximize(row) {
            if (!row.hasOwnProperty('isMaximized')) {
             this.$set(row, 'isMaximized', false);
            }
    
    row.isMaximized = !row.isMaximized;            
    this.$forceUpdate();

            
}



    }
}
</script>

<style>

</style>